<template>
  <div  v-loading="talentLoading" style="min-height: 200px">
    <div v-if="achData && achData.length && !talentLoading">
    <div class="person-item" v-for="(item,i) in achData" :key="i" @click="toDetail(item.id)">
      <div style="margin-left: 8px">
        <div class="person-name">{{ item.title}}</div>
        <div class="item-left flex-wrap" style="width: 100%">
          <label class="no-wrap">发明人：</label>
          <span
            class="item-right" style="margin-right: 9px;flex-shrink: 0"
            v-for="(author,index) in (item.authors && item.authors.length > 3)?item.authors.slice(0,3) : item.authors"
            :key="index"
            :title="author.scholarName"
          >
            <el-avatar fit="cover" :size="14" :src="author.avatarUrl" @error="errorHandler">
              <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
            </el-avatar>
            {{ author.scholarName }}
          </span>
        </div>
        <div class="item-left ellipsis" v-if="false">
          <label>申请人：</label>
          <span class="item-right ellipsis">{{ item.applicantName || '-' }}</span>
        </div>
        <div class="item-left" v-if="false">
          <label>申请时间：</label>
          <span class="item-right">{{ item.applicationDate
          ? formatToDate(item.applicationDate) : '-' }}</span>
        </div>
        <div class="item-left">
          <label>专利类型：</label>
          <span class="item-right" style="margin-right: 10px">{{ item.patentType || '-' }}</span>
        </div>
        <div class="item-left">
          <label>公开日期：</label>
          <span class="item-right">{{ item.publicationDate
          ? formatToDate(item.publicationDate) : '-' }}</span>
        </div>
        <div class="item-left ">
          <label>公开(公告)号：</label>
          <span class="item-right" style="margin-right: 10px">{{ item.publicationNum || '-' }}</span>
        </div>
        <div class="item-left " v-if="false">
          <label>申请号：</label>
          <span class="item-right">{{ item.applicationNum || '-' }}</span>
        </div>
      </div>
    </div>
    </div>
    <div v-else>
      <el-empty/>
    </div>
  </div>
</template>

<script>


import { formatToDate } from '@/utils/dateUtil';

export default {
  name: 'patentList',
  components: {},
  props: ["achData",'talentLoading'],
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    formatToDate,
// 跳转专利详情
    toDetail(id) {
      let obj = {
        name: 'patentDetail',
        query: { id },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },
    errorHandler() {
      return true;
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">

.person-item {
  margin: 5px 19px;
  display: flex;
  cursor: pointer;
  padding: 15px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DEE2E9;

  .person-name {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #181F33;
  }

  .item-left {
    display: flex;
    width: 280px;
    line-height: 24px;
    align-items: center;
    margin-top: 11px;
    font-size: 14px;
    color: #50607F;
    label {
      color: #8191B2;
      white-space: nowrap;
    }
  }

  .item-right {
    font-size: 14px;
    color: #50607F;
  }

  .item-num {
    font-size: 14px;
    color: #464BFE;
    margin-left: 4px;
  }
}

</style>
